module.exports = __webpack_public_path__ + "media/images/front/brands/signature/signature_bg-b7d79e7fd93717adde73268399fdd9c6.webp";